import { Link } from "react-router-dom";
import Footer from "../../../../Components/Footer";
import Header from "../../../../Components/Header";
import PriceBar from "../../../../Components/PriceBar";
import "../index.css";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  getEarnPlanHistory,
  terminateEarnPlan,
} from "../../../../Features/EarnCampaign/earnSlice";
import moment from "moment";
import { toast } from "react-toastify";

function EarnHistory() {
  const { earnPlanHistory, isLoading } = useSelector((state) => state?.earn);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getEarnPlanHistory({ page: page, count: 500 }));
  }, [page]);

  // const handleMore = () => {
  //   setPage(page + 1);
  // };

  const handleTerminate = (id) => {
    dispatch(
      terminateEarnPlan({
        planid: id,
      }),
    ).then((d) => {
      const status = d?.payload?.status;
      const message = d?.payload?.message;
      if (status === 0) {
        toast.success(message);
        dispatch(getEarnPlanHistory({ page: page, count: 50 }));
      } else {
        toast.error(message);
      }
    });
  };

  return (
    <div className="earn-history">
      <Header />
      <PriceBar />
      <div className="container">
        <div className="row pt-5 pb-3 align-items-center">
          <div className="col-12 col-sm-6 pb-2 pb-md-0">
            <h1 className="txtColor text-center text-sm-start text-semibold">
              Earn History
            </h1>
          </div>
          <div className="col-12 col-sm-6 d-flex justify-content-center justify-content-sm-end align-items-center gap-2">
            <Link to="/earn">View All Campaign</Link>
          </div>
        </div>

        {isLoading ? (
          <div className="container mb-5">
            <span className="txtColor">Loading</span>
          </div>
        ) : (
          <>
            <div className="table-responsive mb-5">
              <table className="table">
                <thead>
                  <tr>
                    <th className="head" style={{ width: "11.11%" }}>
                      Joined On
                    </th>
                    <th className="head" style={{ width: "11.11%" }}>
                      Locked
                    </th>
                    <th className="head" style={{ width: "11.11%" }}>
                      Duration
                    </th>
                    <th className="head" style={{ width: "11.11%" }}>
                      Rate
                    </th>
                    <th className="head" style={{ width: "11.11%" }}>
                      Auto Renew
                    </th>
                    <th className="head" style={{ width: "11.11%" }}>
                      Total Earned
                    </th>
                    <th className="head" style={{ width: "11.11%" }}>
                      Last Earned
                    </th>
                    {/* <th className="head" style={{ width: "100px" }}>
                      Bonus Penalty
                    </th>
                    <th className="head" style={{ width: "150px" }}>
                      Principal Penalty
                    </th> */}

                    <th className="head" style={{ width: "11.11%" }}>
                      Status
                    </th>

                    <th className="head" style={{ width: "11.11%" }}>
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {earnPlanHistory?.data?.length > 0 ? (
                    earnPlanHistory?.data?.map((d) => (
                      <tr>
                        <td style={{ width: "11.11%" }}>
                          {moment(d?.JoinedOn).format("DD-MM-YYYY")}
                        </td>
                        <td style={{ width: "11.11%" }}>
                          {d?.PrincipalAmount} {d?.PrincipalCurrency}
                        </td>
                        <td style={{ width: "11.11%" }}>{d?.Duration} days</td>
                        <td style={{ width: "11.11%" }}>{d?.EarnRate}%</td>
                        <td style={{ width: "11.11%" }}>
                          {d?.IsAutoRenew ? "Yes" : "No"}
                        </td>
                        <td style={{ width: "11.11%" }}>
                          {d?.TotalEarned} {d?.PayoutCurrency}
                        </td>
                        <td style={{ width: "11.11%" }}>
                          {d?.LastEarnedBonus} {d?.PayoutCurrency}
                        </td>
                        <td
                          style={{
                            width: "11.11%",
                            color:
                              d?.Status === 10
                                ? "green"
                                : d?.Status === 20
                                  ? "green"
                                  : d?.Status === 30
                                    ? "orange"
                                    : d?.Status === 40
                                      ? "red"
                                      : "None",
                          }}
                        >
                          {d?.Status === 10
                            ? "Active"
                            : d?.Status === 20
                              ? "Redeemed"
                              : d?.Status === 30
                                ? "Matured"
                                : d?.Status === 40
                                  ? "Terminated"
                                  : "None"}
                        </td>

                        <td
                          style={{ width: "11.11%" }}
                          className="d-flex gap-2 justify-content-start"
                        >
                          <Link
                            to={`/earn-plan/${d?.ID}?currency=${d?.PayoutCurrency}`}
                            className="actionBtns"
                          >
                            View
                          </Link>

                          {d?.TerminatedOn === null && (
                            <button
                              className="actionBtns terminate"
                              onClick={() => handleTerminate(d?.ID)}
                            >
                              Terminate
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <div className="py-5 text-center">No Data</div>
                  )}
                </tbody>
              </table>
            </div>
            {/* <div className="d-flex justify-content-start align-items-center gap-2 mb-5">
              <button className="button paginationButton" onClick={handleMore}>
                Load More
              </button>
            </div> */}
          </>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default EarnHistory;
